/* eslint-disable react/jsx-props-no-spreading */
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import AutoAwesomeOutlined from '@mui/icons-material/AutoAwesomeOutlined';

import { Typo } from 'uikit/content';

import TypingText from './typingText';

import styles from '../styles/typingContentRow.module.scss';

const TypingContentRow = ({ typingContent = null, onAnimationComplete = () => {} }) => {
  if (typingContent === null) return null;

  const [isTyping, setIsTyping] = useState(false);

  const rowVariants = {
    hidden: { opacity: 0, height: 0, transition: { duration: 0 } },
    visible: {
      opacity: 1,
      height: 'auto',
      transition: {
        type: 'spring',
        when: 'beforeChildren',
        stiffness: 878,
        damping: 40,
      },
    },
  };

  const iconVariants = {
    hidden: {
      opacity: 0,
      transition: { duration: 0 },
      color: 'var(--ids-color-brand)',
    },
    visible: {
      opacity: 1,
      color: 'var(--ids-color-background-primary-transparent40)',
      transition: {
        delay: 1,
        color: {
          delay: 2,
        },
      },
    },
  };

  const titleWrapperVariants = {
    hidden: { opacity: 0, transition: { duration: 0 } },
    visible: {
      opacity: 1,
      transition: {
        delay: 2,
        when: 'beforeChildren',
      },
    },
  };

  const handleOnAnimationComplete = () => {
    setTimeout(() => {
      onAnimationComplete(typingContent);
    }, 500);
  };

  return (
    <motion.div
      key={`typing-content-row-${typingContent.id}`}
      data-testid={`typing-content-row-${typingContent.id}`}
      className={styles.element}
      initial="hidden"
      animate="visible"
      variants={rowVariants}
    >
      <div className={styles.content}>
        <motion.div
          initial="hidden"
          variants={iconVariants}
          animate="visible"
          className={styles.icon}
        >
          <AutoAwesomeOutlined sx={{ height: 24, width: 24 }} />
        </motion.div>
        <motion.div
          initial="hidden"
          animate="visible"
          variants={titleWrapperVariants}
          onAnimationComplete={() => setIsTyping(true)}
          className={styles.textWrap}
        >
          <Typo element="span" variant="b01" weight="medium">
            <TypingText
              key={`typing-text-${typingContent.id}`}
              text={typingContent.content}
              isTyping={isTyping}
              onAnimationComplete={handleOnAnimationComplete}
            />
          </Typo>
        </motion.div>
      </div>
    </motion.div>
  );
};

TypingContentRow.propTypes = {
  typingContent: PropTypes.shape({
    id: PropTypes.number,
    content: PropTypes.string,
  }),
  onAnimationComplete: PropTypes.func,
};

const areEqual = (prevProps, nextProps) =>
  prevProps.typingContent?.id === nextProps.typingContent?.id;

export default React.memo(TypingContentRow, areEqual);
